import { createBridge } from './bridge'
import { TurnstileExecutor } from './turnstile'

const sitekey = import.meta.env.VITE_TURNSTILE_SITEKEY as string | undefined
if (!sitekey) {
  console.error('[captcha-widget] VITE_TURNSTILE_SITEKEY is not set; all token requests will fail (fail-open on the parent side)')
}

const container = document.getElementById('turnstile-container')!
const executor = new TurnstileExecutor(container, sitekey ?? '')

const bridge = createBridge({
  parentWindow: window.parent,
  getToken: (action) => executor.getToken(action),
})

window.addEventListener('message', (event) => {
  void bridge.handleMessage(event)
})
